import { ReactEditor } from 'slate-react';

function getOwnerDocument(editor) {
  try {
    return ReactEditor.findDocumentOrShadowRoot(editor);
  } catch {
    return document;
  }
}

export { getOwnerDocument };
